// Generated by CoffeeScript 2.7.0
var PrimaryFieldOptions;

export default PrimaryFieldOptions = Vue.extend({
  template: `<div class="setting-wrapper">
  <div class="form-field">
    <div class="form-field-head">
      <div class="form-field-title">主键规则：</div>
      <div class="form-field-description">
        <li>设置主键前，该字段为必填文本输入，填写设置需勾选不允许重复值（单行文本/数字/身份证号码/手机号）</li>
        <li>如果已经存在表单数据，数据中被设置主键字段的填写记录，不允许有重复值，并且不允许为空。</li>
        <li>导入记录的 Excel 如果有两条同样主键记录的行，以最后一条的记录为准。</li>
      </div>
    </div>
  </div>
  <label class="option-item justify-between"
         v-for="option in options"
         :key="option.id"
  >
    <div class="option-label">{{option.name}}</div>
    <div class="tip">
      <input hidden
             type='checkbox'
             :checked="option._selected"
             @change="onOptionValueChangeFunc(option)"
             value='duration' />
      <i class="slp-circle-o"></i>
    </div>
  </label>
  <div class="setting-actions justify-between">
    <div class="left">
    </div>
    <button @click="save">保存</button>
  </div>
</div>`,
  props: {
    datableGID: {
      type: Skylark.Libs.GlobalID,
      required: true
    }
  },
  data: function() {
    return {
      options: []
    };
  },
  methods: {
    onOptionValueChangeFunc: function(option) {
      if (option._selected) {
        return option._selected = false;
      } else {
        _.each(this.options, function(item) {
          if (item._selected) {
            return item._selected = false;
          }
        });
        return option._selected = true;
      }
    },
    save: function() {
      var selected_option;
      selected_option = this.options.find(function(option) {
        return option._selected;
      });
      return Skylark.Libs.Ajax.patch(Skylark.Helpers.UrlHelper.adminUrlFor(this.datableGID.toPath()), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'script',
        data: {
          settings: {
            primary_field_id: selected_option ? selected_option.id : 0
          }
        }
      });
    }
  }
});
